export * from 'Common/config/style';

/* eslint import/export: 0 */
export const FILTER_COLAPSED_ROW_HEIGHT = 46;
